import {Component, computed, input, output, signal} from '@angular/core';
import {mapIconTypeToPrimeIcon} from './icon.mapper';

@Component({
  selector: 'elcia-icon',
  imports: [],
  templateUrl: './icon.html',
  styleUrl: './icon.scss'
})
export class ElciaIcon {
  iconType = input.required<IconType>();
  iconSize = input<IconSize>("md");
  onClick = output();
  remSize = computed(() => {
    switch (this.iconSize()) {
      case 'xs' :
        return '0.75rem';
      case 'sm' :
        return '0.875rem';
      case 'md' :
        return '1rem';
      case 'lg' :
        return '1.125rem';
      case 'xl' :
        return '1.25rem';
      case '2xl' :
        return '1.5rem';
      case '3xl' :
        return '1.875rem';
      case '4xl' :
        return '2.25rem';

      default :
        return '1.5rem';
    }
  });

  iconPrefix = signal('pi');
  primeIcon = computed(() => mapIconTypeToPrimeIcon(this.iconType()));

  protected click() {
    this.onClick.emit()
  }
}

export type IconType =
  'tag'
  | 'server'
  | 'clone'
  | 'copy'
  | 'map'
  | 'finances'
  | 'todo'
  | 'globe'
  | 'minus'
  | 'check'
  | 'credit-note'
  | 'attachment'
  | 'credit-card'
  | 'lock'
  | 'expand'
  | 'filter'
  | 'timesheets'
  | 'collapse'
  | 'right-arrow'
  | 'top-right-arrow'
  | 'bottom-right-arrow'
  | 'plus'
  | 'clock'
  | 'building'
  | 'user'
  | 'file'
  | 'users'
  | 'edit'
  | 'dashboard'
  | 'delete'
  | 'search'
  | 'bell'
  | 'setting'
  | 'send'
  | 'folder-open'
  | 'folder'
  | 'chevron-left'
  | 'chevron-right'
  | 'columns'
  | 'play'
  | 'save'
  | 'chevron-down'
  | 'chart-line'
  | 'download'
  | 'percentage'
  | 'align-center'
  | 'warning'
  | 'sync'
  | 'bolt'
  | 'box'
  | 'stop'
  | 'phone'
  | 'AI'
  | undefined;
export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | undefined;
